// extracted by mini-css-extract-plugin
module.exports = {"container":"SignInScreen_container__37nnO"};